runOnLoad "CustomFields", ->

  # Elements we'll be accessing in this file.
  customFieldType = $("#custom_field_field_type")
  fRequired = $("#custom_field_required_true")
  fDefaultStringInput = $("#custom_field_default_string_input")
  fDefaultStringTextarea = $("#custom_field_default_string_textarea")
  fDefaultInteger = $("#custom_field_default_integer")
  fDefaultDate = $("#custom_field_default_date")
  fDefaultBoolean = $("#custom_field_default_boolean")
  fMinLen = $("#custom_field_minimum_length")
  fMaxLen = $("#custom_field_maximum_length")
  fNumOfRows = $("#custom_field_number_of_rows")
  fMinVal = $("#custom_field_minimum_value")
  fMaxVal = $("#custom_field_maximum_value")
  fInstructions = $("#custom_field_instructions")
  fSelectOptions = $("#custom-field-select-options")
  fHiddenInterpModes = $(".custom_field_interpolation_modes input[type=hidden]")
  fInterpModes = $(".custom_field_interpolation_mode")
  fInterpNL = $("#custom_field_interpolation_html_newlines").closest("label")
  fNumberSupportDecimal = $(".custom_field_number_support_decimal")

  allFields = [
    fRequired,
    fDefaultStringInput, fDefaultStringTextarea, fDefaultInteger, fDefaultDate,
    fDefaultBoolean, fNumOfRows, fMaxLen, fMinLen, fMinVal, fMaxVal,
    fInstructions, fSelectOptions, fHiddenInterpModes, fInterpModes,
    fNumberSupportDecimal,
  ]

  enable = (element_list) ->
    for e in element_list
      e.closest("li.form-field").show()
      e.removeAttr("disabled")

  disable = (element_list) ->
    for e in element_list
      e.closest("li.form-field").hide()
      e.attr(disabled: "")

  updateAvailableCustomFieldOptions = ->

    disable allFields

    switch $("#custom_field_field_type").val()

      when "text"
        enable [ fRequired, fInstructions, fDefaultStringInput, fMaxLen, fMinLen, fHiddenInterpModes, fInterpModes ]
        fInterpNL.hide()

      when "text_multiline"
        enable [ fRequired, fInstructions, fDefaultStringTextarea, fNumOfRows, fHiddenInterpModes, fInterpModes ]
        fInterpNL.show()

      when "number"
        enable [ fRequired, fInstructions, fDefaultInteger, fNumberSupportDecimal, fMinVal, fMaxVal ]

      when "date"
        enable [ fRequired, fInstructions ]

      when "day_of_year"
        enable [ fRequired, fInstructions ]

      when "select_single_dropdown"
        enable [ fRequired, fInstructions, fSelectOptions ]

      when "select_single_radio"
        enable [ fRequired, fInstructions, fSelectOptions ]

      when "select_multiple_checkboxes"
        enable [ fInstructions, fSelectOptions ]

      when "boolean"
        enable [ fRequired, fInstructions, fDefaultBoolean ]

  $("#custom_field_field_type").change(updateAvailableCustomFieldOptions)
  updateAvailableCustomFieldOptions()

  $(".add-custom-field-option-button").click ->
    optionCount = $(".edit-custom-field-option:visible").length
    optionIndex = optionCount + 1
    $.get Routes.empty_option_custom_fields_path(), { index: optionIndex }, (optionHtml) ->
      optionTag = $(optionHtml)
      $(".edit-custom-field-options").append(optionTag)
      optionTag.show()
      optionTag.find("input").focus()
    return false

  suppressOption = (option) ->
    option.find("input.disabled").val("1")
    option.hide()

  $(".edit-custom-field-options").on "click", ".remove-custom-field-option-button", ->
    button = $(this)
    option = button.closest(".edit-custom-field-option")
    value = option.find("input.name").val()
    if value == ""
      suppressOption option
    else
      modalOptions =
        header: t("modals.remove_custom_field_option.header")
        body: t("modals.remove_custom_field_option.body", value: value)
        closeLabel: t("modals.remove_custom_field_option.close_label")
        dangerLabel: t("modals.remove_custom_field_option.danger_label", value: value)
      Dialogs.presentModal modalOptions, (selection) ->
        suppressOption(option) if selection == "danger"
    return false

  fNumberSupportDecimal.on "change", (e) ->
    e.preventDefault()
    isSelected = $(this).find(":checked").val() == "true"
    fNumberSupportDecimal.find(".show-only-when-checked").toggle(isSelected)

  $(".edit-custom-field-options").on "click", ".rename-custom-field-option-button", ->
    $button = $(this)
    $option = $button.closest(".edit-custom-field-option")
    $text   = $option.find(".custom-field-input b")
    $input  = $option.find(".custom-field-input input")

    if $input.is(":visible")
      $input.hide()
      $text.show()
      $button.removeClass("save-button").addClass("edit-button")
      $text.text $input.val()
    else if $text.is(":visible")
      $text.hide()
      $input.show()
      $button.removeClass("edit-button").addClass("save-button")
      $input.focus()
    return false

  # Hide the input field when the user hits enter.
  $(".edit-custom-field-options").on "keydown", ".custom-field-input input", (e) ->
    if e.which == 13
      $input  = $(this)
      $text   = $input.siblings("b")
      $option = $input.closest(".edit-custom-field-option")
      $button = $option.find(".rename-custom-field-option-button")
      $button.removeClass("save-button").addClass("edit-button")
      $text.text $input.val()
      $text.show()
      $input.hide()
      e.preventDefault()
      return false
    return true

  #$(".custom-field-options tbody").sortable({handle: ".move-custom-field-option-button"})

  $(".edit-custom-field-options").arrangeable ".edit-custom-field-option", ".move-custom-field-option-button"

  $(".edit-custom-field-options").on "click", ".move-custom-field-option-button", ->
    Dialogs.presentModal
      header: t("modals.move_custom_field_option.header")
      body: t("modals.move_custom_field_option.body")
    return false
